import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const AuthContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("nfw_admin_token"));

  const isAuthenticated = !!token;

  const login = async (password, email = "") => {
    const body = email ? { email, password } : { password };
    const res = await axios.post(`${API}/admin/login`, body);
    const { token: newToken } = res.data;
    localStorage.setItem("nfw_admin_token", newToken);
    setToken(newToken);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("nfw_admin_token");
    setToken(null);
  };

  const authHeaders = () => ({
    headers: { Authorization: `Bearer ${token}` }
  });

  return (
    <AuthContext.Provider value={{ isAuthenticated, token, login, logout, authHeaders }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
